import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const CheckoutContainer = styled.div`
  max-width: 600px;
  margin: 6rem auto 2rem;
  padding: 2rem;
  background: #fffbe6;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.07);
`;
const Title = styled.h1`
  text-align: center;
  margin-bottom: 2rem;
`;
const Total = styled.div`
  text-align: right;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 2rem;
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;
const Label = styled.label`
  font-weight: 500;
`;
const Input = styled.input`
  padding: 0.7rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
`;
const SubmitButton = styled.button`
  background: #006400;
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s;
  &:hover { background: #004d00; }
`;
const Success = styled.div`
  text-align: center;
  color: #006400;
  font-size: 1.2rem;
  margin-top: 2rem;
`;

export default function Checkout() {
  const { cart, clearCart } = useCart();
  const [form, setForm] = useState({ name: '', phone: '', address: '' });
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    clearCart();
    setSuccess(true);
    setTimeout(() => navigate('/shop'), 2500);
  };

  if (success) {
    return <Success>Comanda a fost plasată cu succes! Vă mulțumim!</Success>;
  }

  return (
    <CheckoutContainer>
      <Title>Oferă comanda</Title>
      <Total>Total: {total.toFixed(2)} LEI</Total>
      <Form onSubmit={handleSubmit}>
        <Label>Nume și prenume
          <Input name="name" value={form.name} onChange={handleChange} required />
        </Label>
        <Label>Telefon
          <Input name="phone" value={form.phone} onChange={handleChange} required />
        </Label>
        <Label>Adresă de livrare
          <Input name="address" value={form.address} onChange={handleChange} required />
        </Label>
        <SubmitButton type="submit">Trimite comanda</SubmitButton>
      </Form>
    </CheckoutContainer>
  );
}